export const NAV_ITEMS = [
  { to: '/today', num: '01', label: 'TODAY' },
  { to: '/calendar', num: '02', label: 'PLAN' },
  { to: '/groceries', num: '03', label: 'STOCK' },
  { to: '/dishes', num: '04', label: 'DISHES' },
  { to: '/progress', num: '05', label: 'PROGRESS' },
  { to: '/settings', num: '06', label: 'SETTINGS' },
]
